import { takeLatest, call, put } from "redux-saga/effects";
import {
  SUBMIT_CORPORATE_AND_ORG_STRUCTURE_REQUEST,
  submitCorporateAndOrgStructureSuccess,
  submitCorporateAndOrgStructureFailure,
} from "../actions/corporateAndOrgStructureActions";
import { fetchCorporateAndOrgStructure } from "../../../services/accIqService";

// Worker Saga
function* handleCorporateAndOrgStructureSubmission(action) {
  try {
    const { dimension, client } = action.payload;
    const response = yield call(
      fetchCorporateAndOrgStructure, 
      dimension, 
      client
    );
    yield put(submitCorporateAndOrgStructureSuccess(response));
  } catch (error) {
    yield put(
      submitCorporateAndOrgStructureFailure(
        error?.message || "Something went wrong"
      )
    );
  }
}

// Watcher Saga
export function* watchCorporateAndOrgStructureSubmission() {
  yield takeLatest(
    SUBMIT_CORPORATE_AND_ORG_STRUCTURE_REQUEST,
    handleCorporateAndOrgStructureSubmission
  );
}
